import type {
  ItemDefinitionResponse,
  ItemDefinitionSimpleResponse,
} from 'src/api/ProactApiClient';
import type {PillProps} from 'src/design/atoms/Pill';
import type {IFormFieldV2} from 'src/types/FormV2';

export const pageTitleDict = {
  singular: 'Item Definition',
  plural: 'Item Definitions',
};

export const itemDefinitionDataListMeta = {
  label: 'name',
};

export const ItemDefinitionMeta = (): IFormFieldV2[] => [
  {
    name: 'active',
    label: 'Active',
    type: 'switch',
    description:
      'Do want to this item to be active? Inactive items are hidden from the user item tracker dashboard.',
  },
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    textboxOptions: {
      validationType: 'safe',
    },
  },
  {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    required: true,
    validation: {
      maxLength: 1000,
    },
  },
  {
    name: 'renewsInDays',
    label: 'Renews in Days',
    type: 'number',
    description:
      'If this item needs to be renewed, enter the number of days it should be renewed in. When that many days have passed, the item will expire and the administrator will be notified to renew it. The assignee is not notified.',
    validation: {
      min: 0,
    },
  },
  {
    name: 'isRequestable',
    label: 'Requestable by Employees',
    type: 'switch',
    description:
      'If enabled, users may request this item through the user item tracker dashboard. If disabled, this item may only be assigned directly by Administrators.',
  },
];

export const CreateDefaultItemDefinition = (): ItemDefinitionResponse => {
  return {
    active: true,
    name: '',
    description: '',
    renewsInDays: undefined,
    isRequestable: true,
  } as ItemDefinitionResponse;
};

export const ItemDefinitionPillConfig = (
  obj?: ItemDefinitionResponse | ItemDefinitionSimpleResponse
): PillProps[] => {
  const pills: PillProps[] = [];

  switch (obj?.active) {
    case true:
      pills.push({
        text: 'Active',
        color: 'blue',
      });
      break;

    case false:
      pills.push({
        text: 'Inactive',
        color: 'yellow',
      });

      break;
    default:
      break;
  }

  switch (obj?.isRequestable) {
    case true:
      pills.push({
        text: 'Requestable',
        color: 'green',
      });
      break;

    case false:
      pills.push({
        text: 'Not Requestable',
        color: 'red',
      });

      break;
    default:
      break;
  }

  return pills;
};

export const itemDefinitionDocumentTitle = 'Item Tracker';
